{
  "el": {
    "survey_type": {
      "actions": {
        "changeResponsible": "Αλλαγή υπευθύνου"
      },
      "attributes": {
        "introduction": "Πρόλογος",
        "responsible": "Υπεύθυνος",
        "title": "Τίτλος"
      },
      "labels": {
        "ask_question": "Τι είδους ερώτηση θέλεις να κάνεις;",
        "editInternalTitle": "Επεξεργασία του εσωτερικού τίτλου;",
        "explainerNPSPart1": "Το Net Promoter Score είναι ένας δείκτης που κυμαίνεται από -100 έως 100 και μετρά τη διάθεση των πελατών να συστήσουν τον οργανισμό ή τα έργα σου σε άλλους.",
        "explainerOpinionScale": "Μέτρησε τον βαθμό συμφωνίας των πελατών σου με μια γενική δήλωση.",
        "fixed_choice": "Ερώτηση πολλαπλής επιλογής",
        "hidePreview": "Απόκρυψη προεπισκόπησης",
        "moreInfo": "Περισσότερες πληροφορίες",
        "nps": "Net Promoter Score",
        "npsQuestion": "NPS",
        "open_ended": "Ανοιχτού τύπου",
        "opinion_scale": "Κλίμακα γνώμης",
        "preview": "Προεπισκόπηση",
        "satisfaction": "Ικανοποίηση",
        "selectSurveyType": "Επιλογή ερωτηματολογίου",
        "showPreview": "Εμφάνιση προεπισκόπησης",
        "tab_summary": "Σύνοψη",
        "tab_units": "Ακίνητα",
        "yes_no": "Ναι-Όχι"
      },
      "navigation": {
        "backToSurveyTypes": "Πίσω στα ερωτηματολόγια"
      },
      "snackbars": {
        "duplicate": "Το ερωτηματολόγιο δημιουργήθηκε, ωστόσο η αντιγραφή από το πρότυπο μπορεί να χρειαστεί μερικά λεπτά για να ολοκληρωθεί."
      },
      "toasts": {
        "bulk_delete": "Το ερωτηματολόγιο διαγράφηκε με επιτυχία | Τα ερωτηματολόγια διαγράφηκαν με επιτυχία",
        "update": "Το ερωτηματολόγιο ενημερώθηκε με επιτυχία"
      },
      "validation": {
        "nameAlreadyTaken": "Το όνομα χρησιμοποιείται ήδη για αυτό το έργο",
        "need_name": "Απαιτείται τίτλος",
        "selectSurveyType": "Επίλεξε τουλάχιστον 1 ερωτηματολόγιο"
      }
    }
  }
}
